var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class CustomerForPaymentsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'customer-for-payments';
    }
    createCustomerForPayments(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/job`,
                data,
            });
        });
    }
    createCustomerForPaymentsSync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    getCustomerForPaymentsJobStatus(jobId_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/job/${jobId}` }, options));
        });
    }
    resumeCustomerById(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/resume-by-id`, data: params }, options));
        });
    }
    suspendCustomerById(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/suspend-by-id`, data: params }, options));
        });
    }
    suspendCustomerByStripeId(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/suspend-by-stripe-id`, data: params }, options));
        });
    }
    suspendNotPayedCustomers() {
        return __awaiter(this, arguments, void 0, function* (params = {}, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/suspend-not-payed`, params }, options));
        });
    }
    suspendBlockedCustomers() {
        return __awaiter(this, arguments, void 0, function* (params = {}, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/suspend-blocked`, params }, options));
        });
    }
    processSubscriptionUpdate(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/subscription-update`, data: params }, options));
        });
    }
}
//# sourceMappingURL=index.js.map